export const getBarcodeCodeEndpoint = 'profilo-ms/ms/profile/getBarcode';
